<template>
  <li :id="DESKTOP_LINKS_ID" class="s-lg-up links-wrap">
    <ul class="links">
      <NavigationItem
        v-for="(item, i) in allItems"
        :key="`${item.label}-${i}`"
        :item="item"
      />
    </ul>
  </li>
</template>

<script lang="ts" setup>
import type { LocaleObject } from '@nuxtjs/i18n'

import { DESKTOP_LINKS_ID } from '@/constants/navigation'
import type {
  PublicMenuItem,
  PublicSecondLevelMenuItem
} from '@/service/__generated-api'

const { locale: currentLocale, locales } = useI18n()

const props = defineProps<{
  items?: PublicMenuItem[]
}>()

const switchLocalePath = useSwitchLocalePath()
const mapLocaleObjectToPublicSecondLevelMenuItem = (
  locale: LocaleObject
): PublicSecondLevelMenuItem => ({
  label: locale.name ?? locale.code,
  link: {
    anchor_type: 'url',
    attachment_file: '',
    icon: '',
    anchor_id: `LANGUAGE_${locale.code}`,
    label: locale.name ?? locale.code,
    slug: '',
    url: switchLocalePath(locale.code),
    video_id: '',
    video_is_vimeo: false
  }
})

const localeSwitcherItems = computed(() =>
  locales.value
    .map(i => (typeof i === 'string' ? { code: i } : i))
    .sort((a, b) => b.code.localeCompare(a.code))
    .map(mapLocaleObjectToPublicSecondLevelMenuItem)
)

const allItems = computed(() => [
  ...(props.items ?? []),
  {
    type: 'language-switcher',
    items: localeSwitcherItems.value,
    label: getLocaleCode(currentLocale.value)
  }
])
</script>

<style lang="scss" scoped>
.links {
  display: flex;
  align-items: center;
  padding: rem(7px) rem(7px) rem(7px) rem(10px);
  background-color: $layout-background-02;
  border-radius: rem(30px);
  box-shadow: $base-shadow;
}
</style>
